const LANDINGPAGES_DATA = [
  {
    id: 1,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/landing_1.png",
    name:"Classic Page 1"
  },
  {
    id: 2,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/landing_2.png",
    name:"Classic Page 2"
  },
  {
    id: 3,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/landing_3.png",
    name:"Classic Page 3"
  },
  {
    id: 4,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/landing_4.png",
    name:"Classic Page 4"
  },
  {
    id: 5,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/landing_5.png",
    name:"Classic Page 5"
  },
  {
    id: 6,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/spa_preview.png",
    name:"Spa"
  },
  {
    id: 7,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_accountant.png",
    name:"Accountant"
  },
  {
    id:8,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_window_cleaning.png",
    name:"Window Cleaning"
  },
  {
    id:9,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_plumbing.png",
    name:"Plumbing"
  },
  {
    id: 10,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_photographer.png",
    name:"Photographer"
  },
  {
    id:11,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_chiropractor.png",
    name:"Chiropractor"
  },
  {
    id: 12,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_carpet.png",
    name:"Carpet Cleaning"
  },
  {
    id: 13,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_daycare.png",
    name:"Day Care"
  },
  {
    id:14,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_landscaping.png",
    name:"Landscaping"
  },
  {
    id: 15,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_dogcare.png",
    name:"Dog Care"
  },
  {
    id:16,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_fitness.png",
    name:"Fitness/Gym"
  },
  {
    id: 17,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_restaurant.png",
    name:"Restaurant"
  },
  {
    id:18,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_realestate.png",
    name:"Real Estate Agent"
  },
  {
    id:19,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_dental.png",
    name:"Dental"
  },
  {
    id:20,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_electrician.png",
    name:"Electrician"
  },
  {
    id:21,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_pest_control.png",
    name:"Pest Control"
  },
  {
    id:22,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_travel.png",
    name:"Travel"
  },
  {
    id:23,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_loyalty.png",
    name:"Loyalty"
  },
  {
    id:24,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_coupon.png",
    name:"Coupon"
  },
  {
    id:25,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_blog.png",
    name:"Blog Intro"
  },
  {
    id:26,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_christmas.png",
    name:"Christmas"
  },
  {
    id:27,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_leadmagnet.png",
    name:"Lead Magnet"
  },
  {
    id:28,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_customer_appre.png",
    name:"Customer Appreciation"
  },
  {
    id:29,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_thanksgiving.png",
    name:"Thanks Giving"
  },
  {
    id:30,
    thumbnail:"https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/landingpages/preview_happybday.png",
    name:"Happy Birthday"
  }
];

export default LANDINGPAGES_DATA;